import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

// 4d5de870


ReactDOM.render(<App />, document.getElementById('root'))